<script>
export default {
    props: ['old'],
    data() {
        return {
            input: {
                login: {
                    model: this.old.login,
                    type: '',
                    message: '',
                    valid: false
                },
                password: {
                    model: this.old.password,
                    type: '',
                    message: '',
                    valid: false
                }
            },
            valid: false
        }
    },
    methods: {
        validateInput(type) {
            this.input[type].type = '';
            this.input[type].valid = false;
            if (!this.input[type].model.length) {
                this.input[type].type = 'is-danger';
            } else {
                this.input[type].valid = true;
            }
            this.valid = true;
            _.each(this.input, (field) => {
                this.valid = this.valid && field.valid;
            });
        }
    },
    created() {
        _.each(this.input, (field, type) => {
            if (this.old[type]) {
                this.validateInput(type);
            }
        });
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/Login.vue